// extracted by mini-css-extract-plugin
export default {"container":"ReviewedReminder_container__cmlsv","likeAnimation":"ReviewedReminder_likeAnimation__57DM3"};